import React, { useEffect, useState } from 'react';
import AlertMessage, { AlertMessageType } from '../../components/AlertMessage';
import Anchor from '../../components/Anchor';
import * as BillingModule from '../../modules/Billing/index';
import Label, { LabelFontFamily } from '../../components/Label';
import Logger from '../../utils/Logger';
import PermissionsManager from '../../utils/PermissionsManager';
import StringFormatter from '../../utils/StringFormatter';
import styled from 'styled-components';
const TAG = 'MissingBillingUserInfoAlertMessage';
const MissingBillingUserInfoAlertMessage = ({ parameters, className, labelText, anchorText, }) => {
    const [billingUserInfoStatusSpec, setBillingUserInfoStatusSpec] = useState(null);
    useEffect(() => {
        const loadBillingUserInfoStatusForCurrentUser = async () => {
            try {
                const loadedBillingUserInfoStatusSpec = await BillingModule.managers.BillingUserInfoStatusManager.loadBillingUserInfoStatusForCurrentUser();
                setBillingUserInfoStatusSpec(loadedBillingUserInfoStatusSpec);
            }
            catch (e) {
                Logger.debug(TAG, "Couldn't not load billingUserInfoStatusSpec");
            }
        };
        if (PermissionsManager.hasOneDirectPermission(['view_billing'])) {
            loadBillingUserInfoStatusForCurrentUser();
        }
    }, []);
    if (!billingUserInfoStatusSpec || billingUserInfoStatusSpec.hasBillingInfo) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(AlertMessageWrapper, { type: AlertMessageType.INFO, className: className },
            React.createElement(InlineLabel, { text: StringFormatter(labelText, parameters), fontFamily: LabelFontFamily.FONT_FAMILY_REGULAR }),
            React.createElement(Anchor, { text: StringFormatter(anchorText, parameters), href: '/o/billing/accounts/' })));
};
const AlertMessageWrapper = styled(AlertMessage) `
    display: flex;
    flex-direction: row;
    margin: 20px 0;
    position: relative;
    padding: 15px 20px;

    box-shadow: 0 0 7px 0 rgba(0,0,0,0.10);
    border-radius: 4px;

    ::before {

        left: 0;
        height: 100%;
        position: absolute;
        top: 0;
        width: 8px;

        background-image: linear-gradient(#00B6E0,#099AC6);
        border-radius: 4px 0 0 4px;
        content: '';
    }
`;
const InlineLabel = styled(Label) `
    display: inline;
    
    margin-right: 5px;
`;
export default MissingBillingUserInfoAlertMessage;
//# sourceMappingURL=MissingBillingUserInfoAlertMessage.js.map